import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

export class ExportService {
    /**
     * מייצא נתונים כקובץ CSV
     * @param data מערך של אובייקטים לייצוא
     * @param fileName שם הקובץ (ברירת מחדל: "export.csv")
     */
    static exportAsCSV(data: Record<string, any>[], fileName: string = "export"): void {
        if (!data || data.length === 0) {
            console.error("No data available to export");
            return;
        }

        if (!fileName.endsWith(".csv")) {
            fileName += ".csv";
        }

        const csvHeaders = Object.keys(data[0]).join(",") + "\n"; // כותרות העמודות
        const csvRows = data.map(row =>
            Object.values(row).map(value => `"${value}"`).join(",")
        ).join("\n");
        const csvContent = csvHeaders + csvRows;

        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        saveAs(blob, fileName);
    }

    /**
     * מייצא נתונים כקובץ Excel
     * @param data מערך של אובייקטים לייצוא
     * @param fileName שם הקובץ (ברירת מחדל: "export.xlsx")
     */
    static exportAsExcel(data: Record<string, any>[], fileName: string = "export"): void {
        if (!data || data.length === 0) {
            console.error("No data available to export");
            return;
        }

        if (!fileName.endsWith(".xlsx")) {
            fileName += ".xlsx";
        }

        const worksheet = XLSX.utils.json_to_sheet(data); // המרת JSON לגיליון עבודה
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
        saveAs(blob, fileName);
    }
}
